var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.543 22.7786C11.8702 22.7786 11.3646 22.6094 11.026 22.2708C10.6918 21.9323 10.5247 21.4223 10.5247 20.7409V10.8646C10.5247 10.1875 10.6918 9.67752 11.026 9.33463C11.3646 8.99175 11.8702 8.82031 12.543 8.82031H15.5312V13.599C15.5312 14.4193 15.9414 14.8294 16.7617 14.8294H21.4753V20.7409C21.4753 21.418 21.306 21.9258 20.9674 22.2643C20.6332 22.6072 20.1298 22.7786 19.457 22.7786H12.543ZM16.7813 13.9375C16.5425 13.9375 16.4232 13.8203 16.4232 13.5859V8.89193C16.5577 8.91363 16.6944 8.97222 16.8333 9.06771C16.9722 9.15885 17.1176 9.28255 17.2695 9.4388L20.8568 13.0911C21.013 13.2517 21.1367 13.3993 21.2279 13.5339C21.319 13.6684 21.3754 13.803 21.3971 13.9375H16.7813Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.dbb68ac9181b644b4cb0e0b6a998a00d.svg";
export { ForwardRef as ReactComponent };